export default function HowWeWork() {
  const steps = [
    {
      number: '01',
      title: 'Analyze',
      description: 'We conduct a comprehensive assessment of your current financial situation, goals, and risk tolerance.',
      icon: 'ri-search-line'
    },
    {
      number: '02',
      title: 'Design',
      description: 'Our experts create a customized strategy tailored to your unique needs and long-term objectives.',
      icon: 'ri-pencil-ruler-2-line'
    },
    {
      number: '03',
      title: 'Implement',
      description: 'We execute your plan with precision, coordinating all necessary steps and documentation.',
      icon: 'ri-rocket-line'
    },
    {
      number: '04',
      title: 'Support',
      description: 'Ongoing monitoring and adjustments ensure your plan stays aligned with your evolving needs.',
      icon: 'ri-customer-service-2-line'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            How We <span className="text-teal-400">Work</span>
          </h2>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto">
            Our proven four-step process ensures comprehensive planning and exceptional results.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-teal-500 to-transparent -translate-x-1/2 z-0"></div>
              )}
              
              <div className="relative bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:border-teal-500/50 transition-all duration-300 hover:bg-white/10 group">
                <div className="mb-6">
                  <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-gradient-to-br from-teal-500 to-teal-600 text-white shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <i className={`${step.icon} text-3xl`}></i>
                  </div>
                  <div className="absolute top-8 right-8 text-6xl font-bold text-white/5 group-hover:text-white/10 transition-colors">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">{step.title}</h3>
                <p className="text-slate-300 leading-relaxed text-sm">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
